import { render, staticRenderFns } from "./SavedRx.vue?vue&type=template&id=5ec41aec&scoped=true"
import script from "./SavedRx.vue?vue&type=script&lang=ts"
export * from "./SavedRx.vue?vue&type=script&lang=ts"
import style0 from "./SavedRx.vue?vue&type=style&index=0&id=5ec41aec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec41aec",
  null
  
)

export default component.exports